import { i18n } from '@/i18n';

export default [i18n.t('common.russia'), i18n.t('common.ukraine'), i18n.t('common.belarus')];

export const segments = {
  SPORTMASTER: 'SPORTMASTER',
  FRANCHISE: 'FRANCHISE',
  SPORTMASTER_KZ: 'SPORTMASTER_KZ',
  SPORTMASTER_AM: 'SPORTMASTER_AM',
  SPORTMASTER_BY: 'SPORTMASTER_BY',
  SPORTMASTER_UZ: 'SPORTMASTER_UZ',
  SPORTMASTER_KG: 'SPORTMASTER_KG',
};

export const phoneCodes = [
  '+7', '+375', '+374', '+996', '+998',
];
